export default "__VITE_ASSET__BWDQN9eH__"